import React, { useContext, useState, useEffect } from 'react'
import AuthContext from '../../context/AuthContext'
import { InlineLoading, Breadcrumb, BreadcrumbItem, Tile, Form, FormGroup, TextInput, Select, SelectItem, Button, InlineNotification, NotificationActionButton } from 'carbon-components-react'
import Toast from '../../components/Notification/Toast';
import { sleep } from '../../utils/functions/tools/sleep';
import SunEditor, { buttonList } from 'suneditor-react';
const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;
const API_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

const FLPTSEmailSettings = ({ match }) => {

    // Variables for modals and toasts
    const [error, setError] = useState(false);
    const [list, setList] = useState([]);
    let toastProperties = null;

    // Other Variables
    let { authTokens } = useContext(AuthContext)
    let [emailSettings, setEmailSettings] = useState(null)
    const [staffEditorContent, setStaffEditorContent] = useState('')
    let [staffSavedState, setStaffSavedState] = useState('No Changes Made')
    const [clientEditorContent, setClientEditorContent] = useState('')
    let [clientSavedState, setClientSavedState] = useState('No Changes Made')
    let [staffEmail, setStaffEmail] = useState('')

    // Inline loading for Test Email
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);
    const [description, setDescription] = useState('Sending...');
    const [ariaLive, setAriaLive] = useState('off');
    const [inlineLoadingState, setInlineLoadingState] = useState('');

    useEffect(() => {
        getEmailSettings()
        document.title = "FLPTS Email Settings | WillowBMS"
    }, [])

    const showToast = (type, title, description) => {
        const id = Math.floor((Math.random() * 100) + 1);
        const time = new Date().toLocaleString();

        switch (type) {
            case 'success':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'success',
                    time: time
                }
                break;
            case 'error':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'error',
                    time: time
                }
                break;
            case 'info':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'info',
                    time: time
                }
                break;
            case 'warning':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'warning',
                    time: time
                }
                break;
            default:
                setList([]);
        }
        setList([...list, toastProperties]);
    }

    let getEmailSettings = async () => {
        let response = await fetch(`${API_URL}/system/settings/email/flpts/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        })
        let data = await response.json()
        setEmailSettings(data)
    }

    let updateEmail = async (values) => {
        values.preventDefault();

        let response = await fetch(`${API_URL}/system/settings/email/flpts/`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({
                'id': 1,
                'staffEmail': values.target.staffEmail.value,
                'staffEmailContent': emailSettings.staffEmailContent,
                'clientEmailContent': emailSettings.clientEmailContent,
            })
        })

        if (response.status === 200) {
            setError(false)
            getEmailSettings()
            showToast("success", "Success", "FLPTS staff email has been saved.")
        } else {
            setError(true)
        }
    }

    let updateEmailContent = async () => {
        let response = await fetch(`${API_URL}/system/settings/email/flpts/`, {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({
                'id': 1,
                'staffEmail': emailSettings.staffEmail,
                'staffEmailContent': staffEditorContent,
                'clientEmailContent': clientEditorContent,
            })
        })

        if (response.status === 200) {
            setError(false)
            getEmailSettings()
            showToast("success", "Success", "FLPTS email content has been saved.")
            setClientSavedState("All Changes Saved")
            setStaffSavedState("All Changes Saved")
        } else {
            setError(true)
        }
    }

    return (
        <div id="body" className="bms-page d-flex">
            {emailSettings &&
                <>
                    <Toast toastList={list} />
                    <div className="wrapper">
                        <Breadcrumb>
                            <BreadcrumbItem href="/system/settings/general">Settings</BreadcrumbItem>
                            <span>FLPTS Email Settings</span>
                        </Breadcrumb>
                        <h2>
                            Settings
                        </h2>
                        <Tile light={true} className="row mt-1">
                            <h5 className="tile-title">Email (SMTP)</h5>
                            {error && <InlineNotification kind="error" hideCloseButton={true} title="Error: Unable to save email (SMTP) settings" subtitle="Please try again or contact your administrator." actions={<NotificationActionButton onClick={(() => setError(false))}>Dismiss</NotificationActionButton>} />}
                            <Form onSubmit={updateEmail}>
                                <FormGroup className="d-flex flex-w">
                                    <div className="col-12 col-md-6 m-005">
                                        <TextInput
                                            id="staffEmail"
                                            labelText="Staff Email Address"
                                            helperText="This is where submission notifications will be sent"
                                            placeholder="Enter the Staff Email Address"
                                            defaultValue={emailSettings?.staffEmail}
                                            onChange={(e) => setStaffEmail(e)}
                                        />
                                    </div>
                                    <div className="col-12 m-005">
                                        <Button type="submit">
                                            Save Changes
                                        </Button>
                                    </div>
                                </FormGroup>
                            </Form>
                        </Tile>

                        <Tile light={true} className="row mt-1">
                            <div className='col-12 w-full d-flex mb-1'>
                                <div className='col-6'>
                                    <h5 className="tile-title">Client Email Content</h5>
                                </div>
                                <div className='col-6 d-flex ml-auto'>
                                    <p className='text-sm text-dark ml-auto mr-05 m-auto'>{clientSavedState}</p>
                                    <Button onClick={() => updateEmailContent()}>Save</Button>
                                </div>
                            </div>
                            {error && <InlineNotification kind="error" hideCloseButton={true} title="Error: Unable to save email (SMTP) settings" subtitle="Please try again or contact your administrator." actions={<NotificationActionButton onClick={(() => setError(false))}>Dismiss</NotificationActionButton>} />}
                            <SunEditor onChange={(e) => setClientEditorContent(e) & setClientSavedState("Unsaved Changes")} defaultValue={emailSettings.clientEmailContent} height="100%" setOptions={{
                                buttonList: [
                                    ['undo', 'redo'],
                                    ['font', 'fontSize', 'formatBlock'],
                                    ['paragraphStyle', 'blockquote'],
                                    ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                                    ['fontColor', 'hiliteColor', 'textStyle'],
                                    ['removeFormat'],
                                    '/', // Line break
                                    ['outdent', 'indent'],
                                    ['align', 'horizontalRule', 'list', 'lineHeight'],
                                    ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.
                                    /** ['imageGallery'] */ // You must add the "imageGalleryUrl".
                                    ['showBlocks', 'codeView'],
                                    ['preview', 'print'],
                                    /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                                ]
                            }} />
                        </Tile>
                        <Tile light={true} className="row mt-1">
                            <div className='col-12 w-full d-flex mb-1'>
                                <div className='col-6'>
                                    <h5 className="tile-title">Staff Email Content</h5>
                                </div>
                                <div className='col-6 d-flex ml-auto'>
                                    <p className='text-sm text-dark ml-auto mr-05 m-auto'>{staffSavedState}</p>
                                    <Button onClick={() => updateEmailContent()}>Save</Button>
                                </div>
                            </div>
                            {error && <InlineNotification kind="error" hideCloseButton={true} title="Error: Unable to save email (SMTP) settings" subtitle="Please try again or contact your administrator." actions={<NotificationActionButton onClick={(() => setError(false))}>Dismiss</NotificationActionButton>} />}
                            <SunEditor onChange={(e) => setStaffEditorContent(e) & setStaffSavedState("Unsaved Changes")} defaultValue={emailSettings.staffEmailContent} height="100%" setOptions={{
                                buttonList: [
                                    ['undo', 'redo'],
                                    ['font', 'fontSize', 'formatBlock'],
                                    ['paragraphStyle', 'blockquote'],
                                    ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                                    ['fontColor', 'hiliteColor', 'textStyle'],
                                    ['removeFormat'],
                                    '/', // Line break
                                    ['outdent', 'indent'],
                                    ['align', 'horizontalRule', 'list', 'lineHeight'],
                                    ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.
                                    /** ['imageGallery'] */ // You must add the "imageGalleryUrl".
                                    ['showBlocks', 'codeView'],
                                    ['preview', 'print'],
                                    /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                                ]
                            }} />
                        </Tile>
                    </div>
                </>
            }
        </div>
    )
}

export default FLPTSEmailSettings